import { addAndTrack, simpleAnTmaker } from "../../../calculators/helpers";
import { geoDmg, Green, Span } from "../../../styledCpns/DataDisplay";
import { CaStamina, mediumPAs, SwordDesc } from "../config";
import {
  checkAscs,
  checkCharMC,
  checkCons,
  findInput,
  makeTlBnes,
  xtraTlLv
} from "../helpers";

const Albedo = {
  code: 29,
  name: "Albedo",
  icon: "3/30/Albedo_Icon",
  sideIcon: "1/12/Character_Albedo_Side_Icon",
  rarity: 5,
  nation: "Mondstadt",
  vision: "Geo",
  weapon: "Sword",
  stats: [
    { "Base HP": 1030, "Base ATK": 20, "Base DEF": 68 },
    { "Base HP": 2671, "Base ATK": 51, "Base DEF": 177 },
    { "Base HP": 3554, "Base ATK": 67, "Base DEF": 235 },
    { "Base HP": 5317, "Base ATK": 101, "Base DEF": 352 },
    { "Base HP": 5944, "Base ATK": 113, "Base DEF": 394, "Geo DMG Bonus": 7.2 },
    { "Base HP": 6839, "Base ATK": 130, "Base DEF": 453, "Geo DMG Bonus": 7.2 },
    {
      "Base HP": 7675,
      "Base ATK": 146,
      "Base DEF": 508,
      "Geo DMG Bonus": 14.4
    },
    {
      "Base HP": 8579,
      "Base ATK": 163,
      "Base DEF": 568,
      "Geo DMG Bonus": 14.4
    },
    {
      "Base HP": 9207,
      "Base ATK": 175,
      "Base DEF": 610,
      "Geo DMG Bonus": 14.4
    },
    {
      "Base HP": 10119,
      "Base ATK": 192,
      "Base DEF": 670,
      "Geo DMG Bonus": 14.4
    },
    {
      "Base HP": 10746,
      "Base ATK": 204,
      "Base DEF": 712,
      "Geo DMG Bonus": 21.6
    },
    {
      "Base HP": 11669,
      "Base ATK": 222,
      "Base DEF": 773,
      "Geo DMG Bonus": 21.6
    },
    {
      "Base HP": 12296,
      "Base ATK": 233,
      "Base DEF": 815,
      "Geo DMG Bonus": 28.8
    },
    {
      "Base HP": 13226,
      "Base ATK": 251,
      "Base DEF": 876,
      "Geo DMG Bonus": 28.8
    }
  ],
  actvTalents: [
    {
      type: "Normal Attack",
      name: "Favonius Bladework - Weiss",
      desc: SwordDesc,
      stats: [
        {
          name: "1-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 36.74,
          multType: 1
        },
        {
          name: "2-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 36.74,
          multType: 1
        },
        {
          name: "3-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 47.45,
          multType: 1
        },
        {
          name: "4-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 49.75,
          multType: 1
        },
        {
          name: "5-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 62.07,
          multType: 1
        },
        {
          name: "Charged Attack",
          dmgTypes: ["CA", "Physical"],
          baseMult: [47.3, 60.2],
          multType: 1
        },
        CaStamina[20],
        ...mediumPAs
      ]
    },
    {
      type: "Elemental Skill",
      name: "Abiogenesis: Solar Isotoma",
      image: "0/0e/Talent_Abiogenesis_Solar_Isotoma",
      desc: [
        {
          content: (
            <>
              Albedo creates a Solar Isotoma using alchemy, which deals AoE{" "}
              {geoDmg} on appearance.
            </>
          )
        },
        {
          heading: "Solar Isotoma",
          content: (
            <>
              has the following properties:
              <br />• When opponents within the Solar Isotoma field take DMG,
              the Solar Isotoma will generate Transient Blossoms which deal AoE{" "}
              {geoDmg}. DMG dealt scales off Albedo's DEF.
              <br />• Transient Blossoms can only be generated once every 2s.
              <br />• When a character is located at the locus of the Solar
              Isotoma, the Solar Isotoma will accumulate Geo power to form a
              crystallized platform that lifts the character up to a certain
              height. Only one crystallized platform can exist at a time.
              <br />• Solar Isotoma is considered a Geo construct. Only one
              Solar Isotoma created by Albedo himself can exist at a time.
            </>
          )
        },
        {
          content: (
            <>
              <Span color="lightGold">Hold</Span> to designate the location of
              the skill.
            </>
          )
        }
      ],
      getXtraLv: xtraTlLv.cons3,
      stats: [
        {
          name: "Skill DMG",
          dmgTypes: ["ES", "Elemental"],
          baseMult: 130.4,
          multType: 2
        },
        {
          name: "Transient Blossom",
          dmgTypes: ["ES", "Elemental"],
          baseSType: "DEF",
          baseMult: 133.6,
          multType: 2,
          getTlBnes: ({ char, selfMCs }) =>
            makeTlBnes(
              checkCharMC(Albedo.buffs, char, selfMCs.BCs, 0),
              "pct",
              [1, 1],
              25
            )
        }
      ],
      otherStats: () => [
        { name: "Duration", value: "30s" },
        { name: "CD", value: "4s" }
      ]
    },
    {
      type: "Elemental Burst",
      name: "Rite of Progeniture: Tectonic Tide",
      image: "0/0a/Talent_Rite_of_Progeniture_Tectonic_Tide",
      desc: [
        {
          content: (
            <>
              Under Albedo's command, Geo crystals surge and burst forth,
              dealing AoE {geoDmg} in front of him.
              <br />
              If a Solar Isotoma created by Albedo himself is on the field, 7
              Fatal Blossoms will be generated in the Solar Isotoma field,
              bursting violently into bloom and dealing AoE {geoDmg}.
            </>
          )
        },
        {
          content: (
            <>
              Tectonic Tide DMG and Fatal Blossom DMG will not generate
              Transient Blossoms.
            </>
          )
        }
      ],
      getXtraLv: xtraTlLv.cons5,
      stats: [
        {
          name: "Burst DMG",
          dmgTypes: ["EB", "Elemental"],
          baseMult: 367.2,
          multType: 2
        },
        {
          name: "Fatal Blossom DMG",
          dmgTypes: ["EB", "Elemental"],
          baseMult: 72,
          multType: 2
        }
      ],
      otherStats: () => [{ name: "CD", value: "12s" }],
      energyCost: 40
    }
  ],
  pasvTalents: [
    {
      type: "Ascension 1",
      name: "Calcite Might",
      image: "5/56/Talent_Calcite_Might",
      desc: (
        <>
          <Green>Transient Blossoms</Green> deal <Green b>25%</Green>{" "}
          <Green>more DMG</Green> to opponents whose HP is below 50%.
        </>
      )
    },
    {
      type: "Ascension 4",
      name: "Homuncular Nature",
      image: "8/80/Talent_Homuncular_Nature",
      desc: (
        <>
          Using Rite of Progeniture: Tectonic Tide increases the{" "}
          <Green>Elemental Mastery</Green> of nearby party members by{" "}
          <Green b>125</Green> for 10s.
        </>
      )
    },
    {
      type: "Passive",
      name: "Flash of Genius",
      image: "3/32/Talent_Flash_of_Genius_%28Albedo%29",
      desc: (
        <>
          When Albedo crafts <Green>Weapon Ascension Materials</Green>, he has a{" "}
          <Green b>10%</Green> <Green>chance</Green> to receive{" "}
          <Green b>double</Green> the product.
        </>
      )
    }
  ],
  constellation: [
    {
      name: "Flower of Eden",
      image: "2/29/Constellation_Flower_of_Eden",
      desc: (
        <>
          Transient Blossoms generated by Albedo's Abiogenesis: Solar Isotoma
          regenerate <Green b>1.2</Green> <Green>Energy</Green> for Albedo.
        </>
      )
    },
    {
      name: "Opening of Phanerozoic",
      image: "d/d8/Constellation_Opening_of_Phanerozoic",
      get desc() {
        return (
          <>
            Transient Blossoms grant Albedo Fatal Reckoning for 30s:
            <br />• {this.buff}
            <br />• This effect stacks up to <Green b>4</Green> times.
          </>
        );
      },
      buff: (
        <>
          Unleashing Rite of Progeniture: Tectonic Tide consumes all stacks of
          Fatal Reckoning. Each stack consumed increases the DMG dealt by{" "}
          <Green>Fatal Blossoms</Green> and{" "}
          <Green>Rite of Progeniture: Tectonic Tide's burst DMG</Green> by{" "}
          <Green b>30%</Green> of Albedo's <Green>DEF</Green>.
        </>
      )
    },
    {
      name: "Grace of Helios",
      image: "e/e8/Constellation_Grace_of_Helios",
      desc: "Abiogenesis: Solar Isotoma"
    },
    {
      name: "Descent of Divinity",
      image: "8/8f/Constellation_Descent_of_Divinity",
      desc: (
        <>
          Active party members within the Solar Isotoma field have their{" "}
          <Green>Plunging Attack DMG</Green> increased by <Green b>30%</Green>.
        </>
      )
    },
    {
      name: "Tide of Hadean",
      image: "a/a1/Constellation_Tide_of_Hadean",
      desc: "Rite of Progeniture: Tectonic Tide"
    },
    {
      name: "Dust of Purification",
      image: "5/52/Constellation_Dust_of_Purification",
      desc: (
        <>
          Active party members within the Solar Isotoma field who are protected
          by a shield created by Crystallize have their <Green>DMG</Green>{" "}
          increased by <Green b>17%</Green>.
        </>
      )
    }
  ],
  buffs: [
    {
      index: 0,
      src: "Ascension 1 Passive Talent",
      desc: () => Albedo.pasvTalents[0].desc,
      affect: "self",
      isGranted: checkAscs[1]
    },
    {
      index: 1,
      src: "Ascension 4 Passive Talent",
      desc: () => Albedo.pasvTalents[1].desc,
      affect: "party",
      isGranted: checkAscs[4],
      addBnes: simpleAnTmaker("ATTRs", "Elemental Mastery", 125)
    },
    {
      index: 2,
      src: "Constellation 2",
      desc: () => Albedo.constellation[1].buff,
      isGranted: checkCons[2],
      affect: "self",
      selfLabels: ["Stacks"],
      inputs: [1],
      inputTypes: ["select"],
      maxs: [4],
      addFinalBnes: ({ ATTRs, hitBnes, charBCs, tkDesc, tracker }) => {
        const bnValue = Math.round(ATTRs.DEF * 0.3 * findInput(charBCs, 2, 0));
        addAndTrack(tkDesc, hitBnes, "EB.flat", bnValue, tracker);
      }
    },
    {
      index: 3,
      src: "Constellation 4",
      desc: () => Albedo.constellation[3].desc,
      affect: "party",
      isGranted: checkCons[4],
      addBnes: simpleAnTmaker("hitBnes", "PA.pct", 30)
    },
    {
      index: 4,
      src: "Constellation 6",
      desc: () => Albedo.constellation[5].desc,
      affect: "party",
      isGranted: checkCons[6],
      addBnes: simpleAnTmaker("hitBnes", "All.pct", 17)
    }
  ]
};

export default Albedo;
